import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import invoiceLogo from "../../../../assets/images/invoicing-icon.svg";
import CommercialAirlineNavigationBar from "../../../../components/element/CommercialAirlineNavigationBar";
import ROUTE_PATHS from "../../../../utils/routePaths";
import ViewIATAFlightDetailsTable from "./Tables/ViewIATAFlightDetailsTable";
import useAirlineAdminApi from "../../../../services/api/useAirlineAdminApi";
import { useQuery } from "@tanstack/react-query";

function ViewIATAFlightDetails() {
  const { fetchIATAInvoiceFlights } = useAirlineAdminApi();
  const [iataInvoicingData, setIATAInvoicingData] = useState(null);

  const {
    data: iataInvoiceFlights,
    isLoading,
    error,
  } = useQuery({
    queryKey: [
      "get-iata-invoice-flight-data",
      iataInvoicingData?.billingDocument,
    ],
    queryFn: () => fetchIATAInvoiceFlights(iataInvoicingData?.billingDocument),
    enabled: !!iataInvoicingData,
  });

  useEffect(() => {
    const storedData = localStorage.getItem("iataInvoicingData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setIATAInvoicingData(parsedData);
    }
  }, []);

  return (
    <div>
      <div className="invoicing-IATA-container">
        <CommercialAirlineNavigationBar
          title={"IATA Flight Details"}
          navigationLogo={invoiceLogo}
          backContent={
            <div className="navigation-header">
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                className="navigation-header-link"
              >
                Home/
              </Link>
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICING_IATA}
                className="navigation-header-link"
              >
                IATA Invoices/
              </Link>
              <Link
                to={ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICING_IATA_VIEW}
                className="navigation-header-link"
              >
                View/
              </Link>
              IATA Flight Details
            </div>
          }
        />
        <div className="invoicing-IATA-table-separator"></div>
        <ViewIATAFlightDetailsTable
          invoicingData={iataInvoiceFlights?.data}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </div>
  );
}

export default ViewIATAFlightDetails;
